export default __webpack_public_path__ + "static/media/modulo-1.4b3cc1b5.svg";